import { Injectable } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';


@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private toast: HotToastService) { }


  success(message: string): any {
    this.toast.success(message);
  }

  warn(message: string): any {
    this.toast.warning(message);
  }


  error(message: string): any {
    this.toast.error(message);
  }
}
